class VendorListDropDownModel {
    constructor({vendorId = null, vendorName = null} = {}) {
        this.vendorId = vendorId;
        this.vendorName = vendorName;
    }

    static fromJson(json) {
        return new VendorListDropDownModel({
            vendorId: json.vendor_id,
            vendorName: json.vendor_name,
        });
    }

    toJson() {
        return {
            vendor_id: this.vendorId,
            vendor_name: this.vendorName,
        };
    }

    static listFromJson(jsonList) {
        return jsonList.map((json) => VendorListDropDownModel.fromJson(json));
    }
}

export default VendorListDropDownModel;
